import { ROLES } from 'permission';
import { levels } from 'constants/constants';
import type { User } from 'store/reducers/types';

interface SelectLike {
  value: string;
  label?: string;
}

export interface JobFilterValues {
  search?: string;
  companies: SelectLike[];
  services: SelectLike[];
  team_leads: SelectLike[];
  opening_team_leads: SelectLike[];
  jobs_statuses: SelectLike[];
  recruiters: SelectLike[];
  openings_statuses: SelectLike[];
  offices: SelectLike[];
  experience_levels: SelectLike[];
  promotion_applied?: boolean;
  [key: string]: unknown;
}

export interface JobTableOptions {
  sorting: { key: string; order: string; field: string };
  limit: { value: number; label: number };
  page: number;
  offset: number;
  itemsCount: number;
}

export const filtersMapper = (filters: JobFilterValues, tableOptions: JobTableOptions) => ({
  search: filters.search,
  company: filters.companies.map(({ value }) => value).join(','),
  service: filters.services.map(({ value }) => value).join(','),
  team_lead: filters.team_leads.map(({ value }) => value).join(','),
  opening_team_lead: filters.opening_team_leads.map(({ value }) => value).join(','),
  status: filters.jobs_statuses.map(({ value }) => value).join(','),
  recruiter: filters.recruiters.map(({ value }) => value).join(','),
  opening_status: filters.openings_statuses.map(({ value }) => value).join(','),
  offices: filters.offices.map(({ value }) => value).join(','),
  experience_level: filters.experience_levels
    .filter(({ value }) => (levels as readonly string[]).includes(value))
    .map(({ value }) => value)
    .join(','),
  experience_custom_level: filters.experience_levels
    .filter(({ value }) => !(levels as readonly string[]).includes(value))
    .map(({ value }) => value)
    .join(','),
  promotion_applied: filters.promotion_applied,
  sorting_field: tableOptions.sorting.field,
  sorting: tableOptions.sorting.order,
  limit: tableOptions.limit.value,
  offset: tableOptions.offset,
});

export const defaultFilters = (user: User) => ({
  team_leads: [],
  recruiters: ([ROLES.RECRUITER, ROLES.RECRUITER_LEAD] as string[]).includes(user.active_role?.name)
    ? [
        {
          label: user.full_name,
          value: user.uuid,
        },
      ]
    : [],
  service: [],
  offices: [],
});
